module.exports = __webpack_public_path__ + "img/mouth_female_thick_mask.f1970c1d.png";